<template>
  <div class="modal-frame modal-large" :class="{active: isOpen}">
    <div class="modal-frame-content">
      <button class="btn-close" type="button" @click="$emit('close')">
        <svg class="svg-cross"><use href="/img/sprite.svg#svg-cross"></use></svg>
      </button>
      <div class="modal-frame-header"><div class="h3">{{ t('orderMessages.historyTitle') }}</div></div>
      <div class="modal-frame-body scroll-y">
        <div v-if="loading" class="table-loader"></div>
        <div v-else-if="error" class="mc-error">{{ error }}</div>
        <p v-else-if="!items.length" class="muted-14">{{ t('orderMessages.empty') }}</p>
        <div v-else class="order-message-history">
          <article v-for="message in items" :key="message.id" class="order-message-history__item">
            <div class="muted-13">{{ formatDate(message.created_at) }} · {{ message.author.name }}</div>
            <p class="font-15 order-message-history__text">{{ message.text }}</p>
            <div class="muted-13">
              {{ message.read ? t('orderMessages.read') : t('orderMessages.unread') }}
              <template v-if="message.read_at"> · {{ formatDate(message.read_at) }}</template>
              <template v-if="message.read_by"> · {{ message.read_by.name }}</template>
            </div>
            <div v-if="message.email_status" class="muted-13">
              {{ t('orderMessages.emailStatus') }}: {{ t(`orderMessages.email.${message.email_status}`) }}
            </div>
          </article>
        </div>
        <div v-if="pagination.pages > 1" class="flex-center">
          <button class="btn-outline" type="button" :disabled="pagination.page <= 1" @click="load(pagination.page - 1)">{{ t('pagination.prev') }}</button>
          <button class="btn-outline" type="button" :disabled="pagination.page >= pagination.pages" @click="load(pagination.page + 1)">{{ t('pagination.next') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {useI18n} from 'vue-i18n';

export default {
  props: {
    isOpen: {type: Boolean, default: false},
    orderId: {type: [Number, String], required: true},
    refreshKey: {type: Number, default: 0},
  },
  emits: ['close'],
  data: () => ({items: [], loading: false, error: '', pagination: {page: 1, pages: 1}}),
  setup() {
    const {t, locale} = useI18n();
    return {t, locale};
  },
  watch: {
    isOpen(value) { if (value) this.load(1); },
    refreshKey() { if (this.isOpen) this.load(1); },
  },
  created() {
    if (this.isOpen) this.load(1);
  },
  methods: {
    async load(page = 1) {
      this.loading = true;
      this.error = '';
      try {
        const response = await axios.get(`/api/order/${this.orderId}/messages/`, {params: {page}});
        if (response.data.status === 'error') throw new Error(response.data.errors?.[0]?.message);
        this.items = response.data.data.items || [];
        this.pagination = response.data.data.pagination || {page: 1, pages: 1};
      } catch (error) {
        this.error = error.message || this.t('orderMessages.loadError');
      } finally {
        this.loading = false;
      }
    },
    formatDate(value) {
      return value ? new Intl.DateTimeFormat(this.locale, {dateStyle: 'short', timeStyle: 'short'}).format(new Date(value)) : '';
    },
  },
};
</script>

<style scoped>
.order-message-history__item { padding: 16px 0; border-bottom: 1px solid #ddd; }
.order-message-history__text { margin: 10px 0; white-space: pre-wrap; overflow-wrap: anywhere; }
</style>
